import { Container, List, Paper, Typography } from '@material-ui/core';
import React, { useState } from "react";
import { TutorialListItem } from "./tutorial-list-item";

const StudentTutorial = () => {


    const urls = {
        'item0': 'LFTMcFKZlWg',
        'item1': '-zEXFWp67pw',
        'item2': 'k-RubNjHJwY',
        'item3': 'HJVcdrgzFww',
        'item4': 'WmgwhwCyBZs',
        'item5': '_1qdMB5WvRY',

    }

    const [state, setState] = useState({
        'item0': false,
        'item1': false,
        'item2': false,
        'item3': false,
        'item4': false,
        'item5': false
    })

    const handleClick = (item) => {
        setState((state) => ({ ...state, [item]: !state[item] }));
    }

    return (
        <Container>
            <Paper style={{ padding: '25px' }}>
                <Typography variant={'h6'}> Tutoriais do aluno</Typography>
                <Typography variant={'body1'}>Nossa equipe preparou uma série de tutoriais para ajudar na compreensão do sistema e sanar as dúvidas mais comuns quanto à utilização do Juristta Office.</Typography>
                <List>
                    <TutorialListItem open={state.item0} label={'Como fazer login'} url={urls.item0} onClick={() => handleClick('item0')} />
                    <TutorialListItem open={state.item1} label={'Dashboard'} url={urls.item1} onClick={() => handleClick('item1')} />
                    <TutorialListItem open={state.item2} label={'Indicação das cores na linha do tempo da atividade'} url={urls.item2} onClick={() => handleClick('item2')} />
                    <TutorialListItem open={state.item3} label={'Entrega de uma atividade/movimentação'} url={urls.item3} onClick={() => handleClick('item3')} />
                    <TutorialListItem open={state.item4} label={'Incluindo notas e anexos no atendimento'} url={urls.item4} onClick={() => handleClick('item4')} />
                    <TutorialListItem open={state.item5} label={'Inserindo partes em um processo'} url={urls.item5} onClick={() => handleClick('item5')} />
                </List>
            </Paper>
        </Container >
    )
}

export default StudentTutorial;